import createHttpClient from './httpClient'

const baseUrl = new URL('/api/v1/insights', process.env.VUE_APP_PUBLIC_SERVICE_BASE_URL).href

const httpClient = createHttpClient(baseUrl)

const InsightsApi = {
  async getSellerOfferInsights(sellerOfferId) {
    const url = `/offer/${sellerOfferId}`
    return await httpClient.get(url)
  },

  async getRevenueChart({ granularityColumn = 'datesByYearMonth' }) {
    const url = '/revenue-insights/revenue'
    const params = { granularityColumn }

    return await httpClient.get(url, { params })
  },

  async getCampaignSpendInsights() {
    const url = '/campaigns/spend'
    return await httpClient.get(url)
  },

  async getRpcByCategoryChart({ startDate = null, endDate = null, accountId = null, categoryName = null } = {}) {
    const url = '/revenue-insights/rpc'
    const params = {}

    if (startDate) {
      params.startDate = startDate
    }

    if (endDate) {
      params.endDate = endDate
    }

    if (accountId) {
      params.accountId = accountId
    }
    
    if (categoryName) {
      params.categoryName = categoryName
    }

    return await httpClient.get(url, { params })
  }
}

export default InsightsApi
